import { createStore } from 'vuex';

import state from './state';
import mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';

import Filter from './modules/Filter';
import FormData from './modules/FormData';
import FormLooking from './modules/FormLooking';
import News from './modules/News';
import Popups from './modules/Popups';
import Service from './modules/Service';
import UsedFilter from './modules/UsedFilter';
import Vikup from './modules/Vikup';

const modules = {
  Filter,
  FormData,
  FormLooking,
  News,
  Popups,
  Service,
  UsedFilter,
  Vikup,
};

const store = createStore({
  state,
  getters,
  mutations,
  actions,
  modules,
});

export default store;
